import { employerHubApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  employerHubApi.get<ProductInfoResponse>('/api/v1/productInfo', config);

export const updateProductDescription = (description: string) =>
  employerHubApi.patch<void>('/api/v1/productInfo', { description });
